import config from '@/config/config.js'

// 腾讯云验证码
export function QcloudCaptchaCode () {
    return new Promise((resolve, reject) => {
        // 定义回调函数
        const callback = (res) => {
            console.log('callback:', res)
            // res（用户主动关闭验证码）= {ret: 2, ticket: null}
            // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
            // res（验证码异常）= {ret: 0, ticket: "String", randstr: "String", errorCode: Number, errorMessage: "String"}

            if (res.ret === 0) {
                resolve({
                    qcloud_ticket: res.ticket,
                    qcloud_randstr: res.randstr,
                    errorCode: res.errorCode,
                    errorMessage: res.errorMessage
                })
            } else {
                resolve(false)
            }
        }

        try {
            // 检查是否已加载验证码JS
            if (typeof TencentCaptcha === 'undefined') {
                // 动态加载验证码JS
                const script = document.createElement('script')
                script.src = 'https://turing.captcha.qcloud.com/TJCaptcha.js'
                script.onload = () => {
                    // JS加载完成后创建验证码实例
                    // eslint-disable-next-line no-undef
                    const captcha = new TencentCaptcha(config.QCLOUD_CAPTCHA_ID, callback, {
                        needFeedBack: false // 关闭反馈按钮
                    })
                    captcha.show()
                }
                document.head.appendChild(script)
            } else {
                // 已加载验证码JS,直接创建实例
                // eslint-disable-next-line no-undef
                const captcha = new TencentCaptcha(config.QCLOUD_CAPTCHA_ID, callback, {
                    needFeedBack: false // 关闭反馈按钮
                })
                captcha.show()
            }
        } catch (error) {
            console.log('error:', error)
            // 容灾处理
            const ticket = 'terror_1001_' + config.QCLOUD_CAPTCHA_ID + '_' + Math.floor(new Date().getTime() / 1000)
            resolve({
                qcloud_ticket: ticket,
                qcloud_randstr: '@' + Math.random().toString(36).substr(2),
                errorCode: 1001,
                errorMessage: 'jsload_error'
            })
        }
    })
}
